import React from 'react'
import { Redirect, useLocation } from 'react-router'

export default function Redirect404() {
    const location = useLocation()

    return <Redirect to={{
        pathname: "/404",
        state: { from: location }
    }} />
}